import languageHelper from "/@/utils/languageHelper.js";
import { ref, onMounted } from "vue";
import Vrouter from "/@/router/index.js";
import i18n from "../i18n/index";
let { locale,messages } = i18n.global;

export const useLanguageMixin = () => {
  let m_currentLanguage = 0;
  const initialLanguage = () => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    if (currentLanguage == 0) {
      localStorage.setItem("lang", "zh-cn");
      locale.value = "zh-cn";
    } else if (currentLanguage == 2) {
      localStorage.setItem("lang", "en");
      locale.value = "en";
    } else if (currentLanguage == 5) {
      localStorage.setItem("lang", "ru");
      locale.value = "ru";
    } else if (currentLanguage == 15) {
      localStorage.setItem("lang", "en_gb");
      locale.value = "en_gb";
    } else if (currentLanguage == 6) {
      localStorage.setItem("lang", "ko");
      locale.value = "ko";
    } else if (currentLanguage == 8) {
      localStorage.setItem("lang", "es");
      locale.value = "es";
    } else {
      localStorage.setItem("lang", "zh-cn");
      locale.value = "zh-cn";
    }
  };
  // 根据路径刷新当前的语言
  const refreshLanguage = (url) => {
    const currentLanguage = getLanguageTypeFromUrl(url);
    m_currentLanguage = currentLanguage;
    if (currentLanguage == 0) {
      localStorage.setItem("lang", "zh-cn");
      locale.value = "zh-cn";
    } else if (currentLanguage == 2) {
      localStorage.setItem("lang", "en");
      locale.value = "en";
    } else if (currentLanguage == 5) {
      localStorage.setItem("lang", "ru");
      locale.value = "ru";
    } else if (currentLanguage == 15) {
      localStorage.setItem("lang", "en_gb");
      locale.value = "en_gb";
    } else if (currentLanguage == 6) {
      localStorage.setItem("lang", "ko");
      locale.value = "ko";
    } else if (currentLanguage == 8) {
      localStorage.setItem("lang", "es");
      locale.value = "es";
    } else {
      localStorage.setItem("lang", "zh-cn");
      locale.value = "zh-cn";
    }
    // window.location.reload()
  };
  //从url中获取语言类型
  const getLanguageTypeFromUrl = (url) => {
    return languageHelper.getTypeFromRout(url);
  };
  //从路由中获取语言类型
  const getLanguageTypeFromRout = () => {
    return languageHelper.getTypeFromRout(window.location.href);
  };
  const gotoPage = (url, query, replace) => {
    if (replace == null) replace = true;
    const router = Vrouter;
    var url_lang = buildCurrentLanguageUrl(url);
    router.push({
      path: url_lang,
      query: query,
      replace: replace,
    });
  };
  const buildCurrentLanguageUrl = (url) => {
    if (url.startsWith("/")) {
      return `/${getCurrentLanguageUrl()}` + url;
    } else {
      return `/${getCurrentLanguageUrl()}/` + url;
    }
  };
  const gotoIndexPage = () => {
    const router = Vrouter;
    router.push({
      path: `/${getCurrentLanguageUrl()}/Index`,
    });
  };
  //获取语言名称(大写)
  const getLanguageParaName = () => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    return languageHelper.getParaNameByType(m_currentLanguage);
  };
  //获取语言类型
  const getCurrentLanguageType = () => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    return m_currentLanguage;
  };
  //获取语言路由字符
  const getCurrentLanguageUrl = () => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    return languageHelper.getRouterUrlByType(m_currentLanguage);
  };
  //获取当前的公司名称(简称)
  const getCorpShortName = () => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    if (m_currentLanguage == 0)
      return window.globalConfig.CorpInfo.CorpShortName.CN;
    if (m_currentLanguage == 2)
      return window.globalConfig.CorpInfo.CorpShortName.EN;
    if (m_currentLanguage == 15)
      return window.globalConfig.CorpInfo.CorpShortName.EN;
    if (m_currentLanguage == 5)
      return window.globalConfig.CorpInfo.CorpShortName.EN;
    if (m_currentLanguage == 6)
      return window.globalConfig.CorpInfo.CorpShortName.KO;
    else return window.globalConfig.CorpInfo.CorpShortName.CN;
  };
  const getSoftName = () => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    if (m_currentLanguage == 0) return window.globalConfig.SoftName.CN;
    if (m_currentLanguage == 2) return window.globalConfig.SoftName.EN;
    if (m_currentLanguage == 15) return window.globalConfig.SoftName.EN;
    if (m_currentLanguage == 5) return window.globalConfig.SoftName.RU;
    if (m_currentLanguage == 6) return window.globalConfig.SoftName.KO;
    else return window.globalConfig.SoftName.CN;
  };
  //获取当前的公司名称(全称)
  const getCorpFullName = () => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    if (m_currentLanguage == 0)
      return window.globalConfig.CorpInfo.CorpFullName.CN;
    if (m_currentLanguage == 2)
      return window.globalConfig.CorpInfo.CorpFullName.EN;
    if (m_currentLanguage == 15)
      return window.globalConfig.CorpInfo.CorpFullName.EN;
    if (m_currentLanguage == 5)
      return window.globalConfig.CorpInfo.CorpFullName.EN;
    if (m_currentLanguage == 6)
      return window.globalConfig.CorpInfo.CorpFullName.KO;
    else return window.globalConfig.CorpInfo.CorpFullName.CN;
  };
  /**
   * 根据语言获取页面的url
   * @param {*} url //路由路径
   * @param {*} lang//需要切换的语言 如：EN、CN、RU等
   */
  const getPageUrlByLang = (url, lang = "CN") => {
    const currentLanguage = getLanguageTypeFromRout();
    m_currentLanguage = currentLanguage;
    let full_url = "";
    let reg = new RegExp(
      languageHelper.getParaNameByType(m_currentLanguage),
      "g"
    );
    full_url = url.replace(reg, lang);
    return full_url;
  };
  return {
    m_currentLanguage,
    initialLanguage,
    refreshLanguage,
    getLanguageTypeFromRout,
    gotoPage,
    buildCurrentLanguageUrl,
    gotoIndexPage,
    getLanguageParaName,
    getCurrentLanguageType,
    getCurrentLanguageUrl,
    getCorpShortName,
    getSoftName,
    getCorpFullName,
    getPageUrlByLang,
  };
};
